import React, { useCallback, useMemo } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";
import { useNodeTypesProvider } from "../../context/reactflow/NodeTypesProvider";

interface SelectHandleNameProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectHandleName: React.FC<SelectHandleNameProps> = ({ color, value, setValue, ...chakraProps }) => {
  const { nodeTypes } = useNodeTypesProvider();

  const handleNames = useMemo(() => {
    const handleNames: string[][] = [];

    nodeTypes.forEach(({ sourceHandles = [] }) =>
      sourceHandles
        .filter(({ handleCategory }) => handleCategory === "data")
        .forEach(({ handleName, label: handleLabel }) => {
          if (handleNames.map(([handleName]) => handleName).includes(handleName)) {
            return;
          }

          handleNames.push([handleName, handleLabel ?? handleName]);
        })
    );

    handleNames.push(["entity", "entity"]);
    handleNames.push(["questId", "questId"]);

    return handleNames;
  }, [nodeTypes]);

  const handleSearch = useCallback(async (searchQuery?: string): Promise<[string, string][]> => {
    return handleNames
      .filter(([_, handleLabel]) =>
        searchQuery ? handleLabel.toLowerCase().includes(searchQuery.toLowerCase().trim()) : true
      )
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([handleName, handleLabel]) => [handleName, handleLabel]);
  }, []);

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"Handle Name"}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectHandleName;
